<div style="border: 1px solid red">connectClient Component</div>